import React, {useState} from "react";
import {getUserName, getUserPhoneNumber, isAllowed} from "../../helpers/authenticator";
import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";
import Main from "../../components/landing-page/Main";
import TrackingPage from "../TrackingPage";
import CheckoutPage from "../CheckoutPage";
import APIDocsPage from "../APIDocsPage";
import general_helper from "../../helpers/general_helper";
import flag from "../../assets/imgs/gh.svg";
import Profile from "../../components/dashboard/Account/Profile";
import API from "../../components/dashboard/Account/API";
import Settlement from "../../components/dashboard/Account/Settlement";
import Business from "../../components/dashboard/Account/Business";

const Account = () => {
    const [viewState, setViewState] = useState("profile");

    const handleOnClick = (viewType) => {
        setViewState(viewType);
    };

    const view = () => {
        switch (viewState) {
            case "profile":
                return <Profile/>;
            case "api":
                return <API/>;
            case "settlement":
                return <Settlement/>;
            case "business":
                return <Business/>;
            default:
                return "";
        }
    };


    return (
        <>
            <div style={{minHeight: 600, marginTop: 150}}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-3">
                            <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                                 aria-orientation="vertical">
                                {
                                    general_helper.getCurrentAccountMenu().map((menu, index) => {
                                        return (
                                            <a key={index} href="#"
                                               className={viewState === menu.key ? "nav-link active text-active" : "nav-link"}
                                               id="v-pills-home-tab"
                                               data-toggle="pill" role="tab" aria-controls="v-pills-home"
                                               onClick={() => {
                                                   handleOnClick(menu.key)
                                               }}
                                               aria-selected="true">{menu.title}</a>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="col-8">
                            <div className="tab-content" id="v-pills-tabContent">
                                {
                                    view()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Account;
